// extracted by mini-css-extract-plugin
export default {"mn-child-inspiration":"index_mn-child-inspiration__XtliQ"};